import React, {useEffect, useRef, useState} from "react";
import styles from "../../Parigi.module.css";

const TypewriterText = ({text, speed = 40, onDone}) => {
    const [shown, setShown] = useState("");
    const onDoneRef = useRef(onDone);

    useEffect(() => {
        onDoneRef.current = onDone;
    }, [onDone]);

    useEffect(() => {
        setShown("");
        let i = 0;
        const interval = setInterval(() => {
            i += 1;
            setShown(text.slice(0, i));
            if (i >= text.length) {
                clearInterval(interval);
                onDoneRef.current && onDoneRef.current();
            }
        }, speed);
        return () => clearInterval(interval);
    }, [text, speed]);

    return (
        <p className={styles.postcardText}>
            {shown}
            <span className={styles.caret} aria-hidden="true">▌</span>
        </p>
    );
};

export default TypewriterText;
